<!--[height]="470"-->
<kendo-grid [data]="invoiceInquiryGridData"
            class="invoiceInquiryGridCls"
            [sortable]="true"
            [selectable]="true"
            [navigable]="true"
            [filterable]="true"
            [groupable]="false"
            [reorderable]="true"
            [resizable]="true"
            [sort]="invoiceGridstate.sort"
            [pageable]="{ buttonCount: 5, info: true, responsive:true, pageSizes:[50,75,100] }"
            [pageSize]="invoiceGridstate.take"
            [skip]="invoiceGridstate.skip"
            [columnMenu]="{  filter: false, sort: false }"
            (sortChange)="invoiceGridSortChange($event)"
            (pageChange)="invoiceGridPageChange($event)"
            (columnReorder)="onReorder($event)"
            (columnVisibilityChange)="onVisibilityChange($event)"
            (columnResize)="onResize($event)"
            (dataStateChange)="invoiceDataStateChange($event)"
            [filter]="invoiceGridSettings.state.filter"
            [loading]="invoiceLoading">
  <ng-template kendoGridToolbarTemplate>
    <div class="k-grid-toolbar-button-display btn-web">
      <button kendoButton class="excel-button " icon="file-excel" [disabled]="loadingExcel" (click)="generateExcel()">
        {{invlblText.exportToExcelLbl?invlblText.exportToExcelLbl:invoiceInquiry.exportToExcelLbl}}
        <kendo-loader *ngIf="loadingExcel"></kendo-loader>
      </button>
      <button kendoButton icon="file-pdf" class="pdf-button " [disabled]="loadingPDF" (click)="generatePDF()">
        {{invlblText.exportToPDFLbl?invlblText.exportToPDFLbl:invoiceInquiry.exportToPDFLbl}}
        <kendo-loader *ngIf="loadingPDF"></kendo-loader>
      </button>
    </div>
    <!--<button kendoGridPDFCommand icon="file-pdf" class="pdf-button">Export to PDF</button>
    <button type="button" class="excel-button" kendoGridExcelCommand icon="file-excel" (click)="excelexport.save()">Export To Excel</button>-->
    <div class="row pwaInvoiceInquirySearch " style="width:100%;">
      <div class="col-sm-3 col-md-2 paddingZero" style="padding-top:2px;">
        Invoice Date:
      </div>
      <div class="col-sm-9 col-md-5  paddingZero paddingRight-10">
        <app-grid-daterange-pwa-filter class="date-range-filter"
                                       [filter]="invoiceGridSettings.state.filter"
                                       field="invoiceDateAsDate">
        </app-grid-daterange-pwa-filter>
      </div>
      <div class="col-sm-12 col-md-5  paddingZero">
        <input placeholder="Search in all columns..."
               kendoTextBox
               (input)="onFilterInvoiceInquiry($event.target.value)" class="searchClass" [(ngModel)]="searchText" />

      </div>

    </div>
    <!--<div class="row">
      <div class="col-12">
        <app-grid-daterange-filter class="date-range-filter"
                                   [filter]="invoiceGridSettings.state.filter"
                                   field="invoiceDateAsDate">
        </app-grid-daterange-filter>-->
    <!--<kendo-daterange>
      <kendo-dateinput class="range-filter dateWidth"
                       kendoDateRangeStartInput
                       [value]="start"
                       (valueChange)="filterRange($event, end)"
                       format="MM/dd/yyyy"
                       [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}"
                       style="width:100px">
      </kendo-dateinput>
      -
      <kendo-dateinput class="range-filter dateWidth"
                       kendoDateRangeEndInput
                       [value]="end"
                       (valueChange)="filterRange(start, $event)"
                       format="MM/dd/yyyy"
                       [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}"
                       style="width:100px">
      </kendo-dateinput>
    </kendo-daterange>-->
    <!--</div>
    </div>-->
  </ng-template>

  <kendo-grid-column media="(max-width: 1024px)" title="Invoice Details">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="row mb-3">
        <div class="col-12 job-name">
          <a class="link" [routerLink]="['/invoice-inquiry/invoice-detail']" (click)="invoiceInquiryData(dataItem.invoiceNumber)">{{dataItem.invoiceNumber}}</a>
          - {{dataItem.jobName}}
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{invoiceInquiry.invoiceDateLbl}}:</span>  <span class="float-right-pwa"> {{dataItem.invoiceDateUIString}}</span>
        </div>
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{invoiceInquiry.invoiceTypeLbl}}:</span><span class="float-right-pwa"> {{dataItem.type}}</span>
        </div>
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{invoiceInquiry.originalAmountLbl}}:</span><span class="float-right-pwa"> {{dataItem.originalAmount}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{invoiceInquiry.amountDueLbl}}:</span><span class="float-right-pwa"> {{dataItem.amountDue}}</span>
        </div>
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{invoiceInquiry.poLbl}}:</span><span class="float-right-pwa"> {{dataItem.po}}</span>
        </div>
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{invoiceInquiry.checkNumberLbl}}:</span><span class="float-right-pwa"> {{dataItem.checkNumber}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{invoiceInquiry.marketSegmentLbl}}:</span><span class="float-right-pwa"> {{dataItem.marketSegment}}</span>
        </div>
      </div>
      <div class="col-sm-4 col-md-4 paddingZero"></div>
      <div class="col-sm-4 col-md-4 paddingZero"></div>
    </ng-template>
  </kendo-grid-column>



  <!--<kendo-grid-checkbox-column [width]="40"></kendo-grid-checkbox-column>-->

  <kendo-grid-column *ngFor="let col of invoiceGridSettings.columnsConfig"
                     [field]="col.field"
                     [title]="col.title"
                     [filter]="col.filter"
                     [filterable]="col.filterable"
                     [hidden]="col.hidden"
                     [format]="col.format" media="(min-width: 1025px)">

    <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'invoiceNumber'">
      <a class="link" [routerLink]="['/invoice-inquiry/invoice-detail']" (click)="invoiceInquiryData(dataItem.invoiceNumber)">{{dataItem.invoiceNumber}}</a>
      <kendo-filter-contains-operator></kendo-filter-contains-operator>
    </ng-template>
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field == 'invoiceDateAsDate'">
      <app-grid-daterange-filter class="date-range-filter"
                                 [filter]="filter"
                                 field="invoiceDateAsDate">
      </app-grid-daterange-filter>
    </ng-template>
    <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'originalAmount'">
      {{dataItem?.originalAmount |currency}}
    </ng-template>
    <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'amountDue'">
      {{dataItem?.amountDue |currency}}
    </ng-template>

    <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem
                 *ngIf="col.field == 'paymentStatus'">
      <app-grid-dropdown-filter [filter]="filter" [data]="paymentStatusList" textField="name" valueField="paymentStatus">
      </app-grid-dropdown-filter>
    </ng-template>
    <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'downloadPdf'">
      <button class="k-button k-grid-remove-command" type="button" (click)="downloadInvoice(dataItem)"  *ngIf="(dataItem.invoiceDateAsDate.getUTCFullYear() > 2022)"
              [disabled]="dataItem.downloadProgress">
        <span class="k-icon k-i-download"></span>
        <kendo-loader *ngIf="dataItem.downloadProgress" style="color:blue"></kendo-loader>
      </button>
    </ng-template>

  </kendo-grid-column>
  <!--<kendo-grid-column field="invoiceNumber"
                     title="{{invoiceInquiryGridColumnLbl.invoiceNumber}}"
                     [filterable]="true">
    <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem>
      <a class="link" [routerLink]="['/invoice-inquiry/invoice-detail']" (click)="invoiceInquiryData(dataItem.invoiceNumber)">{{dataItem.invoiceNumber}}</a>
      <kendo-filter-contains-operator></kendo-filter-contains-operator>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="invoiceDateAsDate" filter="date" format="{0:d}"
                     title="{{invoiceInquiryGridColumnLbl.invoiceDate}}" [width]="220">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <app-grid-daterange-filter class="date-range-filter"
                                 [filter]="filter"
                                 field="invoiceDateAsDate">
      </app-grid-daterange-filter>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="type"
                     title="{{invoiceInquiryGridColumnLbl.type}}">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="po"
                     title="{{invoiceInquiryGridColumnLbl.po}}">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="jobName"
                     title="{{invoiceInquiryGridColumnLbl.jobName}}" [width]="200">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="originalAmount"
                     title="{{invoiceInquiryGridColumnLbl.originalAmount}}">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="amountDue"
                     title="{{invoiceInquiryGridColumnLbl.amountDue}}">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="checkNumber"
                     title="{{invoiceInquiryGridColumnLbl.checkNumber}}">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="marketSegment"
                     title="{{invoiceInquiryGridColumnLbl.marketSegment}}">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="invoiceStatus"
                     title="{{invoiceInquiryGridColumnLbl.invoiceStatus}}">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>-->
  <ng-template kendoGridNoRecordsTemplate>
  </ng-template>
  <!--<ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
    <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
    <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
    <kendo-pager-info></kendo-pager-info>
    <kendo-pager-next-buttons></kendo-pager-next-buttons>
    <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
  </ng-template>-->
  <!--<kendo-grid-pdf fileName="InvoiceInquiry.pdf" [allPages]="false" paperSize="A4" [landscape]="true">
    <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
    <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
      <div class="page-template">
        <div class="header">
          <img src="../../../assets/images/kawneer_logo.JPG" alt="Kawneer logo" width="150" height="70">
        </div>
        adjjhjjj
        <div class="footer">
          ©1991-2021 CDI Technology, LLC. All rights reserved.
        </div>
      </div>
    </ng-template>
  </kendo-grid-pdf>-->


  <kendo-excelexport [data]="data" [collapsible]="true" fileName="InvoiceInquiry.xlsx" #excelexport>
    <kendo-excelexport-column field="invoiceNumber" title="InvoiceNumber" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="invoiceDate" title="InvoiceDate" [width]="350">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="type" title="Type" [width]="150">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="poNumber" title="PO#" [width]="150">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="jobName" title="JobName" [width]="250">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="originalAmount" title="OriginalAmount" [width]="150">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="amount" title="Amount" [width]="150">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="checkNumber" title="CheckNumber" [width]="150">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="marketSegment" title="MarketSegment" [width]="250">
    </kendo-excelexport-column>
    <!--<kendo-excelexport-column field="invoiceStatus" title="InvoiceStatus" [width]="150">
    </kendo-excelexport-column>-->
  </kendo-excelexport>
</kendo-grid>


<div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row" style="text-align: center">
  <!--Show/hide based on some logic-->
  <button kendoButton       
          (click)="proceedToPaymentScreen()"
          *ngIf="showPaymentOptions"
          class="m-3 clearKendoButton btn btn-success" style="margin: 0 auto;">
    Go To Account Payment Screen
  </button>
</div>

